import { BsList } from "solid-icons/bs";
import { FaSolidArrowDown, FaSolidArrowUp } from "solid-icons/fa";
import { SortIconWrapper } from "./styled";

const SortIcon = () => {
	return (
		<SortIconWrapper>
			<FaSolidArrowDown font-size="15px" class="left" />
			<BsList />
			<FaSolidArrowUp font-size="15px" class="right" />
		</SortIconWrapper>
	);
};
export default SortIcon;
